<!--suppress CheckEmptyScriptTag -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       x="0px"
       y="0px"
       viewBox="0 0 72 72"
       style="enable-background:new 0 0 72 72;"
       xml:space="preserve">
    <rect width="26"
          height="31"
          x="7"
          y="8"
          stroke="#796E65"
          class="stroke"
          fill="none"
          stroke-width="2"/>
    <rect width="26"
          height="19"
          x="7"
          y="45"
          stroke="#796E65"
          class="stroke"
          fill="none"
          stroke-width="2"/>
    <rect width="26"
          height="19"
          x="39"
          y="8"
          stroke="#796E65"
          class="stroke"
          fill="none"
          stroke-width="2"/>
    <rect width="26"
          height="31"
          x="39"
          y="33"
          stroke="#796E65"
          class="stroke"
          fill="none"
          stroke-width="2"/>
</svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgBoard'
}
</script>
